module.exports = __webpack_public_path__ + "static/media/bg2.0e6056d5.jpg";